import { VT_NRF54L_HID_REPORT } from '../../shared/nordic/nrf54l'

// ============================================================
// 基础协议命令
// ============================================================
export const CMD_VT_nrf54L = {
  switch_work_mode: [0xa0],
  code_match_mode: [0xa1, 0x8f],
  clear_code_status: [0xa1, 0x82],
  device_pairing_status: [0xa1, 0x01],
  firmware_version: [0xa3, 0xb0],
  read_eeprom: [0xa4],
  write_eeprom: [0xa5],
  cfg_select: [0xa6],
  reset_device: [0xa7],
  read_work_mode: [0xa7],
  firmware_update: [0xa8, 0xb1],
  get_dpi: [0xa9],
  read_battery: [0xaa],
  init_default_flash: [0xad],
} as const

// ============================================================
// 协议通用配置（Report ID / ACK 值等）
// ============================================================
export const PROTOCOL_CONFIG_VT_nrf54L = {
  report_id: VT_NRF54L_HID_REPORT.outputReportId,
  feature_report_id: VT_NRF54L_HID_REPORT.featureReportId,
  busy_ack_value: VT_NRF54L_HID_REPORT.busyAck, // 0x02 表示设备忙碌，需要重试
  read_ack_value: VT_NRF54L_HID_REPORT.okAck, // 0x01 表示读取成功
} as const

// ============================================================
// IAP 升级相关常量 TODO 未确认
// ============================================================
// 升级命令
export const CMD_IAP_PROM = 0x80
export const CMD_IAP_ERASE = 0x81
export const CMD_IAP_VERIFY = 0x82
export const CMD_IAP_END = 0x83
export const CMD_IAP_FW_INFO = 0x84

// 需要进入 BootLoader 的单区设备 PID 列表
export const SINGLE_PID_LIST: number[] = [0x4822, 0x4823, 0x4a00]
